import React from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import Image from "next/legacy/image";
import Link from "next/link";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";
import breakpoints from "../../shared/constants";
import NavigationColumns from "./NavigationColumns";
import SocialMediaLinks from "./SocialMediaLinks";

const StyledFooter = styled.footer`
  background-color: ${({ theme, $backgroundColour }) =>
    $backgroundColour || theme.footerBackgroundColor};
  color: ${({ theme }) => theme.negativeTextColor};

  a {
    text-decoration: none;
    color: inherit;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const StyledText = styled.span`
  font-size: 28px;
  line-height: 31px;
  width: 80%;

  @media (min-width: ${breakpoints.TABLET}) {
    width: 50%;
  }

  @media (min-width: ${breakpoints.DESKTOP}) {
    font-size: 34px;
    line-height: 38px;
    width: 65%;
  }
`;

const StyledPhoneNumber = styled.span`
  font-size: 2rem;
  white-space: nowrap;

  @media (min-width: ${breakpoints.TABLET}) {
    font-size: 3rem;
    margin-bottom: 4.5rem;
  }

  @media (min-width: ${breakpoints.DESKTOP}) {
    font-size: 3.75rem;
    margin-bottom: 4.5rem;
  }

  font-weight: 700;
  position: relative;
`;

function CenteredFooter(props) {
  const { navigationStore, configStore, footerStore } = useStores();

  const { footerLinks, socialmediaNavigation } = navigationStore;
  const { config } = configStore;
  const { footerText } = footerStore;

  const bottomSectionClassName = classNames("d-flex align-items-center", {
    "justify-content-between": !isEmpty(socialmediaNavigation),
    "justify-content-end": isEmpty(socialmediaNavigation),
  });

  const logoUrl = config?.logo?.url;
  const phoneNumber = config?.contact?.phoneNumber;

  return (
    <StyledFooter $backgroundColour={props?.backgroundColour}>
      <div className="container-xxl py-4">
        <div className="row pt-lg-5">
          {logoUrl && (
            <div className="mb-4 d-flex flex-column">
              <Link href={config?.logoUrl || "/"}>
                <Image
                  alt={config?.siteName}
                  height={config?.logoHeight}
                  src={logoUrl}
                  width={config?.logoWidth}
                />
              </Link>
            </div>
          )}
          <div className="col-lg-4 d-flex mb-4">
            {footerText && <StyledText>{footerText}</StyledText>}
          </div>
          <div className="col-lg-4 d-flex flex-column">
            {phoneNumber && (
              <StyledPhoneNumber className="d-flex mb-5 mb-lg-5 fw-bold">
                {phoneNumber}
              </StyledPhoneNumber>
            )}

            {!isEmpty(footerLinks) && (
              <div>
                <NavigationColumns
                  navigationItemClassName="mb-3"
                  navigationLinks={footerLinks}
                />
              </div>
            )}
          </div>
        </div>
        <div className={bottomSectionClassName}>
          {!isEmpty(socialmediaNavigation) && (
            <SocialMediaLinks mediaLinksWrapperClassName={null} />
          )}
          <span>
            <span className="me-5">
              Site by <a href="https://talent-funnel.com">Talent Funnel</a>
            </span>
            <Link href="/sitemap">Sitemap</Link>
          </span>
        </div>
      </div>
    </StyledFooter>
  );
}

export default CenteredFooter;
